import { render, staticRenderFns } from "./TMultiselect.vue?vue&type=template&id=036a7ac5&scoped=true&"
import script from "./TMultiselect.vue?vue&type=script&lang=js&"
export * from "./TMultiselect.vue?vue&type=script&lang=js&"
import style0 from "./TMultiselect.vue?vue&type=style&index=0&id=036a7ac5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036a7ac5",
  null
  
)

/* custom blocks */
import block0 from "./TMultiselect.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports